export const filterSeoQueryStringParams = (seoQueryString) => {
    if (!seoQueryString) {
        return '';
    }
    const whiteListedSeoparams = ['roomi', 'rooma', 'lat', 'lon', 'gfmi', 'gfma', 'sort', 'ffs', 'sr', 'cp', 'sp', 'p'];
    const seoQueryStringParams = new URLSearchParams(seoQueryString);
    const results = [];
    seoQueryStringParams.forEach((value, key) => {
        if (whiteListedSeoparams.includes(key)) {
            results.push(`${key}=${value}`);
        }
    });
    return results.join('&');
};
